import { useCallback, useMemo, useState } from 'react';
import flag from '~/assets/icons/flag.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { SearchInput } from '~/components/ui/SearchInput';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	NumberPlatesRegion,
	setRegion,
	setStage,
	StageTypes,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledContainer,
	StyledInputContainer,
	StyledNumberContainer,
	StyledRegionContainer,
	StyledRegionList,
	StyledSelectButton,
} from './VehicleRegistrationRegionSelection.styled';

const VehicleRegistrationRegionSelection = () => {
	const dispatch = useLayoutDispatch();
	const region = useLayoutSelector(
		(state) => state.vehicleRegistrationSlice.region,
	);
	const regionList = useObservable(rage.vehicleShop.getNumberPlateRegions());
	const indexedRegionList = useMemo(
		() => regionList.map((e, index) => ({ ...e, index })),
		[regionList],
	);
	const [filteredRegionList, setFilteredRegionList] =
		useState(indexedRegionList);

	const handleRegionSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		const inputText = event.currentTarget.value.toLowerCase().trim();
		const filteredList = indexedRegionList.filter((region) => {
			let matched = true;

			const regionArea = region.name.toLowerCase();
			const regionAreaMatch = inputText.match(/\D+/g);
			if (regionAreaMatch !== null) {
				regionAreaMatch.forEach((match) => {
					matched &&= regionArea.includes(match.trim());
				});
			}

			const regionNumber = region.code.toString();
			const regionNumberMatch = inputText.match(/\d+/g);
			if (regionNumberMatch !== null) {
				regionNumberMatch.forEach((match) => {
					matched &&= regionNumber.includes(match.trim());
				});
			}

			return matched;
		});
		setFilteredRegionList(filteredList);
	};

	const handleButtonClick = useCallback(() => {
		dispatch(setStage(StageTypes.Main));
	}, []);

	const handleRegionSelect = useCallback((region: NumberPlatesRegion) => {
		dispatch(setStage(StageTypes.Main));
		dispatch(setRegion(region));
	}, []);

	return (
		<StyledContainer>
			<SectionHeading text={'Выберите регион'} icon={flag} />
			<StyledInputContainer>
				<SearchInput
					placeholder="Выберите регион для поиска"
					tabIndex={-1}
					style={{ padding: '0 54px 0 20px' }}
					iconStyle={{
						right: '20px',
					}}
					onChange={handleRegionSearch}
				/>
			</StyledInputContainer>
			<StyledRegionList tabIndex={-1}>
				{filteredRegionList.map((item) => (
					<StyledRegionContainer
						key={item.code}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						<StyledNumberContainer>
							<Text>{item.code}</Text>
						</StyledNumberContainer>
						<Text>{item.name}</Text>
						<StyledSelectButton
							color={ButtonColors.Default}
							height={ButtonHeight.Height30}
							$selected={region?.code === item.code}
							onClick={() => handleRegionSelect(item)}
						>
							<Text>{region?.code === item.code ? 'Выбрано' : 'Выбрать'}</Text>
						</StyledSelectButton>
					</StyledRegionContainer>
				))}
			</StyledRegionList>
			<Button
				color={ButtonColors.Default}
				height={ButtonHeight.Height50}
				onClick={handleButtonClick}
				style={{ marginTop: 30 }}
			>
				<Text>Отменить</Text>
			</Button>
		</StyledContainer>
	);
};

export { VehicleRegistrationRegionSelection };
